// extracted by mini-css-extract-plugin
export default {"wrap":"NoPermission_wrap__vYZyT","icon":"NoPermission_icon__EGD18","title":"NoPermission_title__FH2iy","desc":"NoPermission_desc__weV-g"};